module.exports = __webpack_public_path__ + "static/media/4-3.37cb3478.webp";